import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { get } from '@atlas/core';

import Input from 'common/Input';

const InputWithActionButton = ({ field, onBlur = () => {}, onChange, onFocus = () => {} }) => {
  const {
    active,
    autofocus,
    disabled,
    errors,
    info,
    label,
    name,
    placeholder,
    touched,
    value,
    warnings,
  } = field;
  const inputValue = value ?? '';
  const error = touched && errors[0];
  const warning = touched ? get(warnings, '[0].message') : null;

  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);

  return (
    <Input
      active={active}
      autoFocus={autofocus}
      disabled={disabled}
      error={error}
      info={info}
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={changeHandler}
      onFocus={onFocus}
      placeholder={placeholder}
      touched={touched}
      value={inputValue}
      warning={warning}
      withActionButtons
      withTranslate
    />
  );
};

InputWithActionButton.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default InputWithActionButton;
